import { render, staticRenderFns } from "./swappDialog.vue?vue&type=template&id=1959ae0c&scoped=true&"
import script from "./swappDialog.vue?vue&type=script&lang=js&"
export * from "./swappDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1959ae0c",
  null
  
)

export default component.exports